import type { FinanceiroDashboard } from '@/domain/model/FinanceiroDashboard';
import type { GetFinanceiroDashboardUseCase } from '@/application/port/in/GetFinanceiroDashboardUseCase';
import type { FinanceiroDashboardGateway } from '@/application/port/out/FinanceiroDashboardGateway';

export class GetFinanceiroDashboard implements GetFinanceiroDashboardUseCase {
  constructor(private readonly gateway: FinanceiroDashboardGateway) {}
  execute(): Promise<FinanceiroDashboard> {
    return this.gateway.fetch();
  }
}
